/* tslint:disable */
/* eslint-disable */
/**
 * Copilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AutoMappingField
 */
export interface AutoMappingField {
    /**
     * 
     * @type {string}
     * @memberof AutoMappingField
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AutoMappingField
     */
    'data_type': string;
    /**
     * 
     * @type {string}
     * @memberof AutoMappingField
     */
    'type': AutoMappingFieldTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AutoMappingFieldTypeEnum {
    SOURCE = 'source',
    DESTINATION = 'destination'
}

/**
 * 
 * @export
 * @interface AutoMappingRequest
 */
export interface AutoMappingRequest {
    /**
     * 
     * @type {Array<AutoMappingField>}
     * @memberof AutoMappingRequest
     */
    'fields': Array<AutoMappingField>;
    /**
     * 
     * @type {Context}
     * @memberof AutoMappingRequest
     */
    'context': Context;
    /**
     * 
     * @type {string}
     * @memberof AutoMappingRequest
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface AutoMappingResponse
 */
export interface AutoMappingResponse {
    /**
     * 
     * @type {Array<MappingSuggestion>}
     * @memberof AutoMappingResponse
     */
    'mappings': Array<MappingSuggestion>;
    /**
     * 
     * @type {string}
     * @memberof AutoMappingResponse
     */
    'id': string;
}
/**
 * @type Context
 * @export
 */
export type Context = { type: 'flow' } & FlowAutoMappingContext | { type: 'flow_loop' } & FlowLoopAutoMappingContext;

/**
 * @type Context1
 * @export
 */
export type Context1 = { context_type: 'feature_query' } & FeatureQueryConversationContext | { context_type: 'node' } & NodeConversationContext;

/**
 * 
 * @export
 * @interface ConversationMessage
 */
export interface ConversationMessage {
    /**
     * 
     * @type {string}
     * @memberof ConversationMessage
     */
    'role': ConversationMessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ConversationMessage
     */
    'content': string;
    /**
     * 
     * @type {ToolUse}
     * @memberof ConversationMessage
     */
    'tool_use'?: ToolUse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum ConversationMessageRoleEnum {
    USER = 'user',
    COPILOT = 'copilot'
}

/**
 * 
 * @export
 * @interface ConverseRequest
 */
export interface ConverseRequest {
    /**
     * 
     * @type {string}
     * @memberof ConverseRequest
     */
    'conversation_id': string;
    /**
     * 
     * @type {string}
     * @memberof ConverseRequest
     */
    'completion_id': string;
    /**
     * 
     * @type {Context1}
     * @memberof ConverseRequest
     */
    'context': Context1;
    /**
     * 
     * @type {Array<ConversationMessage>}
     * @memberof ConverseRequest
     */
    'messages': Array<ConversationMessage>;
}
/**
 * 
 * @export
 * @interface ConverseResponse
 */
export interface ConverseResponse {
    /**
     * 
     * @type {string}
     * @memberof ConverseResponse
     */
    'completion_id': string;
    /**
     * 
     * @type {string}
     * @memberof ConverseResponse
     */
    'conversation_id': string;
    /**
     * 
     * @type {Array<ConversationMessage>}
     * @memberof ConverseResponse
     */
    'messages': Array<ConversationMessage>;
}
/**
 * 
 * @export
 * @interface FeatureQueryConversationContext
 */
export interface FeatureQueryConversationContext {
    /**
     * 
     * @type {string}
     * @memberof FeatureQueryConversationContext
     */
    'context_type': FeatureQueryConversationContextContextTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FeatureQueryConversationContext
     */
    'current_query'?: string | null;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof FeatureQueryConversationContext
     */
    'mentioned_entities'?: Array<{ [key: string]: any; }> | null;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof FeatureQueryConversationContext
     */
    'mentioned_events'?: Array<{ [key: string]: any; }> | null;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof FeatureQueryConversationContext
     */
    'event_schemas'?: Array<{ [key: string]: any; }> | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureQueryConversationContext
     */
    'last_error_message'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum FeatureQueryConversationContextContextTypeEnum {
    FEATURE_QUERY = 'feature_query'
}

/**
 * 
 * @export
 * @interface FlowAutoMappingContext
 */
export interface FlowAutoMappingContext {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowAutoMappingContext
     */
    'data_typing'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowAutoMappingContext
     */
    'data_sample'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowAutoMappingContext
     */
    'input_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowAutoMappingContext
     */
    'output_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof FlowAutoMappingContext
     */
    'type': FlowAutoMappingContextTypeEnum;
    /**
     * 
     * @type {FlowNodeDefinition}
     * @memberof FlowAutoMappingContext
     */
    'node_definition': FlowNodeDefinition;
}

/**
    * @export
    * @enum {string}
    */
export enum FlowAutoMappingContextTypeEnum {
    FLOW = 'flow'
}

/**
 * 
 * @export
 * @interface FlowLoopAutoMappingContext
 */
export interface FlowLoopAutoMappingContext {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowLoopAutoMappingContext
     */
    'data_typing'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowLoopAutoMappingContext
     */
    'data_sample'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowLoopAutoMappingContext
     */
    'input_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowLoopAutoMappingContext
     */
    'output_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof FlowLoopAutoMappingContext
     */
    'type': FlowLoopAutoMappingContextTypeEnum;
    /**
     * 
     * @type {FlowLoopNodeDefinition}
     * @memberof FlowLoopAutoMappingContext
     */
    'node_definition': FlowLoopNodeDefinition;
}

/**
    * @export
    * @enum {string}
    */
export enum FlowLoopAutoMappingContextTypeEnum {
    FLOW_LOOP = 'flow_loop'
}

/**
 * 
 * @export
 * @interface FlowLoopNodeDefinition
 */
export interface FlowLoopNodeDefinition {
    /**
     * 
     * @type {string}
     * @memberof FlowLoopNodeDefinition
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowLoopNodeDefinition
     */
    'type': FlowLoopNodeDefinitionTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowLoopNodeDefinition
     */
    'meta': { [key: string]: any; };
}

/**
    * @export
    * @enum {string}
    */
export enum FlowLoopNodeDefinitionTypeEnum {
    FLOW_LOOP = 'flow_loop'
}

/**
 * 
 * @export
 * @interface FlowNodeDefinition
 */
export interface FlowNodeDefinition {
    /**
     * 
     * @type {string}
     * @memberof FlowNodeDefinition
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowNodeDefinition
     */
    'type': FlowNodeDefinitionTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FlowNodeDefinition
     */
    'meta': { [key: string]: any; };
}

/**
    * @export
    * @enum {string}
    */
export enum FlowNodeDefinitionTypeEnum {
    FLOW = 'flow'
}

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface MappingSuggestion
 */
export interface MappingSuggestion {
    /**
     * 
     * @type {string}
     * @memberof MappingSuggestion
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof MappingSuggestion
     */
    'destination': string;
}
/**
 * 
 * @export
 * @interface NodeConversationContext
 */
export interface NodeConversationContext {
    /**
     * 
     * @type {string}
     * @memberof NodeConversationContext
     */
    'context_type': NodeConversationContextContextTypeEnum;
    /**
     * 
     * @type {NodeDefinitionDto}
     * @memberof NodeConversationContext
     */
    'node_definition': NodeDefinitionDto;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NodeConversationContext
     */
    'data_typing'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NodeConversationContext
     */
    'data_sample'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NodeConversationContext
     */
    'parameters'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NodeConversationContext
     */
    'input_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NodeConversationContext
     */
    'output_schema'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof NodeConversationContext
     */
    'mentioned_nodes'?: Array<{ [key: string]: any; }> | null;
}

/**
    * @export
    * @enum {string}
    */
export enum NodeConversationContextContextTypeEnum {
    NODE = 'node'
}

/**
 * 
 * @export
 * @interface NodeDefinitionDto
 */
export interface NodeDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof NodeDefinitionDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NodeDefinitionDto
     */
    'type': NodeDefinitionDtoTypeEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NodeDefinitionDto
     */
    'meta': { [key: string]: any; };
}

/**
    * @export
    * @enum {string}
    */
export enum NodeDefinitionDtoTypeEnum {
    TRANSFORM = 'transform',
    ASSIGNMENT_NODE = 'assignment_node',
    RULE_2 = 'rule_2',
    FLOW = 'flow',
    FLOW_LOOP = 'flow_loop',
    SQL_DATABASE_CONNECTION_NODE = 'sql_database_connection_node',
    SPLIT_2 = 'split_2',
    SCORECARD = 'scorecard',
    ML = 'ml'
}

/**
 * 
 * @export
 * @interface ToolApproval
 */
export interface ToolApproval {
    /**
     * 
     * @type {string}
     * @memberof ToolApproval
     */
    'type'?: ToolApprovalTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ToolApproval
     */
    'tool_use_id': string;
    /**
     * 
     * @type {string}
     * @memberof ToolApproval
     */
    'tool_name': ToolApprovalToolNameEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolApproval
     */
    'tool_input': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ToolApproval
     */
    'status': ToolApprovalStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ToolApprovalTypeEnum {
    APPROVAL = 'approval'
}
/**
    * @export
    * @enum {string}
    */
export enum ToolApprovalToolNameEnum {
    GET_TABLES = 'get_tables',
    GET_TABLE_DETAILS = 'get_table_details',
    GET_BATCH_TABLE_DETAILS = 'get_batch_table_details'
}
/**
    * @export
    * @enum {string}
    */
export enum ToolApprovalStatusEnum {
    APPROVED = 'approved',
    DENIED = 'denied'
}

/**
 * 
 * @export
 * @interface ToolRequest
 */
export interface ToolRequest {
    /**
     * 
     * @type {string}
     * @memberof ToolRequest
     */
    'type'?: ToolRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ToolRequest
     */
    'tool_use_id': string;
    /**
     * 
     * @type {string}
     * @memberof ToolRequest
     */
    'tool_name': ToolRequestToolNameEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolRequest
     */
    'tool_input': { [key: string]: any; };
}

/**
    * @export
    * @enum {string}
    */
export enum ToolRequestTypeEnum {
    REQUEST = 'request'
}
/**
    * @export
    * @enum {string}
    */
export enum ToolRequestToolNameEnum {
    GET_TABLES = 'get_tables',
    GET_TABLE_DETAILS = 'get_table_details',
    GET_BATCH_TABLE_DETAILS = 'get_batch_table_details'
}

/**
 * 
 * @export
 * @interface ToolResult
 */
export interface ToolResult {
    /**
     * 
     * @type {string}
     * @memberof ToolResult
     */
    'type'?: ToolResultTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ToolResult
     */
    'tool_use_id': string;
    /**
     * 
     * @type {string}
     * @memberof ToolResult
     */
    'tool_name': ToolResultToolNameEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolResult
     */
    'tool_input': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ToolResult
     */
    'status': ToolResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ToolResult
     */
    'content': string;
}

/**
    * @export
    * @enum {string}
    */
export enum ToolResultTypeEnum {
    RESULT = 'result'
}
/**
    * @export
    * @enum {string}
    */
export enum ToolResultToolNameEnum {
    GET_TABLES = 'get_tables',
    GET_TABLE_DETAILS = 'get_table_details',
    GET_BATCH_TABLE_DETAILS = 'get_batch_table_details'
}
/**
    * @export
    * @enum {string}
    */
export enum ToolResultStatusEnum {
    SUCCESS = 'success',
    ERROR = 'error',
    DENIED = 'denied'
}

/**
 * 
 * @export
 * @interface ToolUse
 */
export interface ToolUse {
    /**
     * 
     * @type {string}
     * @memberof ToolUse
     */
    'type'?: ToolUseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ToolUse
     */
    'tool_use_id': string;
    /**
     * 
     * @type {string}
     * @memberof ToolUse
     */
    'tool_name': ToolUseToolNameEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ToolUse
     */
    'tool_input': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ToolUse
     */
    'status': ToolUseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ToolUse
     */
    'content': string;
}

/**
    * @export
    * @enum {string}
    */
export enum ToolUseTypeEnum {
    REQUEST = 'request',
    APPROVAL = 'approval',
    RESULT = 'result'
}
/**
    * @export
    * @enum {string}
    */
export enum ToolUseToolNameEnum {
    GET_TABLES = 'get_tables',
    GET_TABLE_DETAILS = 'get_table_details',
    GET_BATCH_TABLE_DETAILS = 'get_batch_table_details'
}
/**
    * @export
    * @enum {string}
    */
export enum ToolUseStatusEnum {
    SUCCESS = 'success',
    ERROR = 'error',
    DENIED = 'denied'
}

/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Converse with the Copilot
         * @param {ConverseRequest} converseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        converseCopilotApiV1ConversePost: async (converseRequest: ConverseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'converseRequest' is not null or undefined
            assertParamExists('converseCopilotApiV1ConversePost', 'converseRequest', converseRequest)
            const localVarPath = `/copilot/api/v1/converse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(converseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get auto-mapping suggestion
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet: async (mappingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet', 'mappingId', mappingId)
            const localVarPath = `/copilot/api/v1/auto-mapping/{mapping_id}`
                .replace(`{${"mapping_id"}}`, encodeURIComponent(String(mappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get auto-mapping suggestions
         * @param {AutoMappingRequest} autoMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoMappingSuggestionsCopilotApiV1AutoMappingPost: async (autoMappingRequest: AutoMappingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autoMappingRequest' is not null or undefined
            assertParamExists('getAutoMappingSuggestionsCopilotApiV1AutoMappingPost', 'autoMappingRequest', autoMappingRequest)
            const localVarPath = `/copilot/api/v1/auto-mapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autoMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the completion response
         * @param {string} completionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationOutputCopilotApiV1ConverseCompletionIdGet: async (completionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completionId' is not null or undefined
            assertParamExists('getConversationOutputCopilotApiV1ConverseCompletionIdGet', 'completionId', completionId)
            const localVarPath = `/copilot/api/v1/converse/{completion_id}`
                .replace(`{${"completion_id"}}`, encodeURIComponent(String(completionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Converse with the Copilot
         * @param {ConverseRequest} converseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async converseCopilotApiV1ConversePost(converseRequest: ConverseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConverseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.converseCopilotApiV1ConversePost(converseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.converseCopilotApiV1ConversePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get auto-mapping suggestion
         * @param {string} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet(mappingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoMappingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet(mappingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get auto-mapping suggestions
         * @param {AutoMappingRequest} autoMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoMappingSuggestionsCopilotApiV1AutoMappingPost(autoMappingRequest: AutoMappingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoMappingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoMappingSuggestionsCopilotApiV1AutoMappingPost(autoMappingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAutoMappingSuggestionsCopilotApiV1AutoMappingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the completion response
         * @param {string} completionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationOutputCopilotApiV1ConverseCompletionIdGet(completionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConverseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationOutputCopilotApiV1ConverseCompletionIdGet(completionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConversationOutputCopilotApiV1ConverseCompletionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Converse with the Copilot
         * @param {DefaultApiConverseCopilotApiV1ConversePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        converseCopilotApiV1ConversePost(requestParameters: DefaultApiConverseCopilotApiV1ConversePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConverseResponse> {
            return localVarFp.converseCopilotApiV1ConversePost(requestParameters.converseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get auto-mapping suggestion
         * @param {DefaultApiGetAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet(requestParameters: DefaultApiGetAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutoMappingResponse> {
            return localVarFp.getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet(requestParameters.mappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get auto-mapping suggestions
         * @param {DefaultApiGetAutoMappingSuggestionsCopilotApiV1AutoMappingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoMappingSuggestionsCopilotApiV1AutoMappingPost(requestParameters: DefaultApiGetAutoMappingSuggestionsCopilotApiV1AutoMappingPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutoMappingResponse> {
            return localVarFp.getAutoMappingSuggestionsCopilotApiV1AutoMappingPost(requestParameters.autoMappingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the completion response
         * @param {DefaultApiGetConversationOutputCopilotApiV1ConverseCompletionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationOutputCopilotApiV1ConverseCompletionIdGet(requestParameters: DefaultApiGetConversationOutputCopilotApiV1ConverseCompletionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConverseResponse> {
            return localVarFp.getConversationOutputCopilotApiV1ConverseCompletionIdGet(requestParameters.completionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for converseCopilotApiV1ConversePost operation in DefaultApi.
 * @export
 * @interface DefaultApiConverseCopilotApiV1ConversePostRequest
 */
export interface DefaultApiConverseCopilotApiV1ConversePostRequest {
    /**
     * 
     * @type {ConverseRequest}
     * @memberof DefaultApiConverseCopilotApiV1ConversePost
     */
    readonly converseRequest: ConverseRequest
}

/**
 * Request parameters for getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGetRequest
 */
export interface DefaultApiGetAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet
     */
    readonly mappingId: string
}

/**
 * Request parameters for getAutoMappingSuggestionsCopilotApiV1AutoMappingPost operation in DefaultApi.
 * @export
 * @interface DefaultApiGetAutoMappingSuggestionsCopilotApiV1AutoMappingPostRequest
 */
export interface DefaultApiGetAutoMappingSuggestionsCopilotApiV1AutoMappingPostRequest {
    /**
     * 
     * @type {AutoMappingRequest}
     * @memberof DefaultApiGetAutoMappingSuggestionsCopilotApiV1AutoMappingPost
     */
    readonly autoMappingRequest: AutoMappingRequest
}

/**
 * Request parameters for getConversationOutputCopilotApiV1ConverseCompletionIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetConversationOutputCopilotApiV1ConverseCompletionIdGetRequest
 */
export interface DefaultApiGetConversationOutputCopilotApiV1ConverseCompletionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetConversationOutputCopilotApiV1ConverseCompletionIdGet
     */
    readonly completionId: string
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Converse with the Copilot
     * @param {DefaultApiConverseCopilotApiV1ConversePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public converseCopilotApiV1ConversePost(requestParameters: DefaultApiConverseCopilotApiV1ConversePostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).converseCopilotApiV1ConversePost(requestParameters.converseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get auto-mapping suggestion
     * @param {DefaultApiGetAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet(requestParameters: DefaultApiGetAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoMappingSuggestionCopilotApiV1AutoMappingMappingIdGet(requestParameters.mappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get auto-mapping suggestions
     * @param {DefaultApiGetAutoMappingSuggestionsCopilotApiV1AutoMappingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAutoMappingSuggestionsCopilotApiV1AutoMappingPost(requestParameters: DefaultApiGetAutoMappingSuggestionsCopilotApiV1AutoMappingPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAutoMappingSuggestionsCopilotApiV1AutoMappingPost(requestParameters.autoMappingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the completion response
     * @param {DefaultApiGetConversationOutputCopilotApiV1ConverseCompletionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getConversationOutputCopilotApiV1ConverseCompletionIdGet(requestParameters: DefaultApiGetConversationOutputCopilotApiV1ConverseCompletionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConversationOutputCopilotApiV1ConverseCompletionIdGet(requestParameters.completionId, options).then((request) => request(this.axios, this.basePath));
    }
}



